import {LocalStorageService} from "./LocalStorageService"

//import supported translations
import {en, fa} from '../translations';

const Langages = Object.freeze({
    ENG: 1,
    FA: 2
});

/** LanguageService namespace
 * @namespace
 */
export const LanguageService = {

    defaultLang: 'en',

    supportedLanguges: {
        'en': {id: Langages.ENG, name: "English", key: 'en', code: "us", translations: en},
        'fa': {id: Langages.FA, name: "فارسی", key: 'fa', code: "fa", translations: fa},
    },

    /**Get selected language*/
    getSelectedLanguage: function () {
        const selectedLang = LocalStorageService.get('selected_language');

        if (selectedLang) {
            return selectedLang;
        }

        return this.defaultLang;
    },

    /**Set selected language
     * @param {string} langCode - The language code.
     */
    setSelectedLanguage: function (langCode) {

        if (this.supportedLanguges[langCode]) {
            LocalStorageService.set("selected_language", langCode);
        }
    },

    /**Get translation by language code
     * @param {string} langCode - The language code.
     */
    getTranslation: function (langCode) {
        if (langCode) {
            if (langCode !== this.defaultLang) {
                this.supportedLanguges[langCode].translations.messages = {...this.supportedLanguges[this.defaultLang].translations.messages, ...this.supportedLanguges[langCode].translations.messages}
            }
            return this.supportedLanguges[langCode].translations;
        }
        return this.supportedLanguges[this.defaultLang].translations;
    }
}


// WEBPACK FOOTER //
// ./src/services/LanguageService.js